import React from 'react';
import c from 'classnames';
import s from './Title.scss';
const Title = ({ value, isConcise, className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['title'], isConcise && s['concise'], className)
    }, value);
};
Title.displayName = 'Title';
export default Title;
